export const translations = {
  no: {
    // Główne
    appName: 'SafeVisit',
    appDescription: 'Visitor management that works',
    
    // Nawigacja
    dashboard: 'Hovedpanel',
    reception: 'Resepsjon',
    logout: 'Logg ut',
    
    // Logowanie
    login: 'Logg inn',
    register: 'Registrer',
    email: 'E-post',
    password: 'Passord',
    companyName: 'Firmanavn',
    companyAddress: 'Firmaadresse',
    companyPhone: 'Firmatelefon',
    loginButton: 'Logg inn',
    registerCompany: 'Registrer firma',
    
    // Dashboard
    currentGuests: 'Nåværende gjester',
    fireAlarm: 'Brannalarm',
    exportList: 'Eksporter liste',
    
    // Formularz gościa
    fullName: 'Fullt navn',
    company: 'Bedrift',
    phone: 'Telefonnummer',
    hostName: 'Person som besøkes',
    guestEmail: 'E-post (valgfritt)',
    emailDescription: 'ID-kort vil bli sendt til denne e-posten',
    registerGuest: 'Registrer gjest',
    registering: 'Registrerer...',
    
    // Recepcja
    newGuest: 'Ny gjest',
    cancel: 'Avbryt',
    newGuestRegistration: 'Registrering av ny gjest',
    qrScanner: 'QR-skanner',
    scanDescription: 'Skann gjestens QR-kode for å melde dem ut',
    scannerNote: '(Skannerfunksjon krever kamera og tilleggsimplementering)',
    
    // Terminal gości
    welcomeTo: 'Velkommen til',
    guestRegistration: 'Gjesteregistrering',
    registrationComplete: 'Velkommen!',
    registrationSuccess: 'Du er nå registrert som gjest. Ha en fin dag!',
    collectId: 'Du kan nå besøke firmaet',
    registerAnother: 'Registrer ny gjest',
    important: '',
    keepQr: 'Husk telefonnummeret ditt - det trengs ved utsjekking.',
    
    // Akcje
    checkOut: 'Meld ut',
    printBadge: 'Skriv ut',
    
    // Statusy
    noGuests: 'Ingen gjester på området',
    present: 'Tilstede',
    
    // Alarmy
    confirmAlarm: 'Er du sikker på at du vil utløse brannalarm?',
    alarmTriggered: 'Alarm utløst! Evakueringsliste generert.',
    
    // Błędy
    registrationError: 'Registreringsfeil',
    loadingError: 'Feil ved lasting av data',
    
    // PDF
    guest: 'GJEST',
    guestId: 'GJESTE-ID',
    evacuationList: 'EVAKUERINGSLISTE',
    date: 'Dato',
    numberOfPeople: 'Antall personer',
    serialNumber: 'Løpenr.',
    nameHeader: 'Navn',
    companyHeader: 'Firma',
    phoneHeader: 'Telefon',
    
    // Checkout
    checkout: 'Utsjekking',
    scanQr: 'Skann QR-kode',
    searchByPhone: 'Søk med telefonnummer',
    enterPhone: 'Skriv inn telefonnummer',
    search: 'Søk',
    guestsFound: 'Funnet gjester',
    visiting: 'Besøker',
    checkingOut: 'Melder ut...',
    checkoutComplete: 'Utsjekking fullført!',
    hasBeenCheckedOut: 'har blitt meldt ut',
    thanksForVisit: 'Takk for besøket!',
    checkoutAnother: 'Meld ut en annen gjest',
    noGuestsFound: 'Ingen gjester funnet med dette nummeret',
    scanQrDescription: 'Skann din QR-kode for å melde deg ut',
    qrScannerNote: '(QR-skanner krever kamera og tilleggsimplementering)',
    
    // Placeholders
    namePlaceholder: 'Ola Nordmann',
    companyPlaceholder: 'Bedriftsnavn',
    phonePlaceholder: '+47 123 45 678',
    hostPlaceholder: 'Kari Hansen',
    emailPlaceholder: 'ola@email.no',
    
    // Email messages
    emailWouldBeSent: 'ID-kort ville blitt sendt til',
    emailConfigRequired: 'E-postfunksjon krever konfigurering av EmailJS eller Supabase Functions',
    collectIdMessage: 'Gå til resepsjonen for å hente ID-kortet ditt',
    todayRegistered: 'I dag registrert',
    quickRegistration: 'Hurtigregistrering',
    receptionPanel: 'Resepsjons Panel',
    panel: 'Panel',
    checkIn: 'Inngang',
    guestTerminals: 'Gjesteterminaler',
    checkInRegistration: 'Innsjekking (Registrering)',
    checkOutDeparture: 'Utsjekking (Avreise)',
    guestPanel: 'Gjestepanel - Terminallenker',
    openRegistrationTerminal: 'Åpne registreringsterminal',
    openCheckoutTerminal: 'Åpne utsjekkingsterminal',
    copyLinkToEmail: 'Kopier link til e-post',
    linkForSharing: 'Link til deling',
    instructionsForUse: 'Instruksjoner for bruk',
    forTabletKiosk: 'For tablet/kiosk:',
    forEmailInvitations: 'For e-post invitasjoner:',
    clickOpenTerminal: 'Klikk "Åpne terminal" for å åpne i fullskjerm',
    placeTabletAtEntrance: 'Plasser tablet ved inngang/utgang',
    guestsCanSelfRegister: 'Gjester kan selv registrere seg',
    copyLinkAndSend: 'Kopier link og send til gjester',
    guestsCanPreRegister: 'Gjester kan registrere seg på forhånd',
    worksOnAllDevices: 'Fungerer på alle enheter',
    terminalForNewGuests: 'Terminal for ankommende gjester',
    terminalForDepartingGuests: 'Terminal for avreisende gjester',
    guestPanelDescription: 'Åpne panel med lenker til terminaler. Du kan sende lenker på e-post eller sette opp på nettbrett.',
    linkCopiedToClipboard: 'Link {type} został skopiowany do schowka!',
    failedToCopyLink: 'Nie udało się skopiować linku. Skopiuj ręcznie: {link}',
    copyManually: 'Nie udało się skopiować linku. Skopiuj ręcznie:',
    triggeringAlarm: 'Utløser alarm...',
    clickToScan: 'Klikk for å skanne',
    holdQrToCamera: 'Hold QR-koden foran kameraet',
    manualEntry: 'Manuell innføring',
    enterQrCode: 'Skriv inn QR-kode:',
    qrNotFound: 'Ingen gjest funnet med denne QR-koden',
    qrScanError: 'Feil ved skanning av QR-kode',
    cameraError: 'Feil ved tilgang til kamera',
    cameraNotSupported: 'Kamera støttes ikke i denne nettleseren',
    frontCamera: 'Frontkamera',
    backCamera: 'Bakkamera',
    invalidPhone: 'Ugyldig telefonnummer. Bruk format: 12345678 eller +47 12345678',
    invalidEmail: 'Ugyldig e-postadresse',
    recentCheckouts: 'Nylig utsjekket',
    noRecentCheckouts: 'Ingen nylige utsjekkinger',
    duration: 'Varighet',

    privacyPolicy: 'Personvernerklæring',
    lastUpdated: 'Sist oppdatert',
    privacyNotice: 'Ved å registrere deg godtar du vår',
    privacyConsent: 'Jeg godtar',
    privacyRequired: 'Du må godta personvernerklæringen for å fortsette',
    dataDeletedOnCheckout: 'Dine data slettes automatisk når du sjekker ut',
    phoneRequired: 'Telefonnummer er påkrevd',
    needHelp: 'Trenger du hjelp? Kontakt resepsjonen',
    thankYou: 'Takk!',
    noInternet: 'Ingen internettforbindelse',
    tapToRegister: 'Trykk her for å registrere deg',
    tapToCheckout: 'Trykk her for å melde deg ut',
    hostPhone: 'Telefon til vert',
    hostPhonePlaceholder: '+47 987 65 432',
    hostPhoneDescription: 'For å varsle om ankomst',
    hostPhoneRequired: 'Telefon til vert er påkrevd',
    smsNotification: 'Gjest ankommet',
    emergencySMS: 'Nød-SMS sendt',
    smsResults: 'SMS resultater',
    smsSent: 'SMS sendt',
    smsSimulation: 'SMS simulering - sjekk konsoll',
    
    // Terminal translations
    systemActive: 'System aktiv',
    connected: 'Tilkoblet',
    disconnected: 'Frakoblet',
    lastUpdated: 'Sist oppdatert',
    newGuest: 'Ny gjest',
    register: 'Registrer deg',
    fillInformation: 'Fyll ut dine opplysninger',
    getAccess: 'Få tilgang til bygningen',
    notifyContact: 'Varsle din kontaktperson',
    clickToStart: 'Trykk for å starte',
    leaving: 'Forlater',
    enterPhone: 'Skriv inn ditt telefonnummer',
    confirmCheckout: 'Bekreft utsjekking',
    clickToCheckout: 'Trykk for å melde ut',
    howToUse: 'Slik bruker du terminalen',
    step1: 'Velg "Registrer deg" når du ankommer',
    step2: 'Fyll ut skjemaet med dine opplysninger',
    step3: 'Meld deg ut når du forlater bygningen',
    needHelp: 'Trenger du hjelp?',
    contactReception: 'Kontakt resepsjonen hvis du har problemer',
    callReception: 'Ring resepsjonen',
    orGoToReception: 'Eller gå til resepsjonen for personlig hjelp',
    
    // Registration and checkout specific
    pleaseFillinformation: 'Vennligst fyll ut informasjonen nedenfor',
    nowRegistered: 'Du er nå registrert som gjest',
    goToReceptionOrHost: 'Gå til resepsjonen eller til personen du skal besøke',
    rememberPhone: 'Husk ditt telefonnummer',
    neededForCheckout: 'Trenger dette for utsjekking når du forlater bygningen',
    informReception: 'Informer resepsjonen når du forlater bygningen',
    orUseCheckoutTerminal: 'Eller bruk utsjekking-terminalen ved utgangen',
    autoReturn: 'Automatisk retur til terminal om',
    seconds: 'sekunder',
    backToTerminalNow: 'Tilbake til terminal nå',
    enterPhoneToCheckout: 'Skriv inn ditt telefonnummer for å melde deg ut',
    searching: 'Søker...',
    nowCheckedOut: 'Du er nå utsjekket fra bygningen',
    haveNiceDay: 'Ha en fin dag!',
    
    // Form validation
    companyRequired: 'Bedrift er påkrevd',
    emailRequired: 'E-post er påkrevd',
    
    // Welcome messages
    welcomeMessage: 'Velkommen!',
    
    // Registration approval system
    registrationPending: 'Registrering sendt! Vent på godkjenning fra administrator.',
    guestManagementSystem: 'Visitor management that works',
    signIn: 'Logg inn',
    loading: 'Laster...',
    settings: 'Innstillinger',
    companyLogo: 'Bedriftslogo',
    removeLogo: 'Fjern logo',
    uploading: 'Laster opp...',
    uploadLogo: 'Last opp logo',
    chooseFile: 'Velg fil',
    back: 'Tilbake',
    forgotPassword: 'Glemt passord?',
    resetEmailSent: 'E-post med tilbakestilling av passord er sendt!',
    resetError: 'Feil ved sending av e-post med tilbakestilling av passord',
    confirmPassword: 'Bekreft passord',
    passwordMinLength: 'Minimum 8 tegn',
    passwordUppercase: 'En stor bokstav',
    passwordLowercase: 'En liten bokstav',
    passwordNumber: 'Ett tall',
    passwordSpecial: 'Ett spesialtegn (!@#$%^&*)',
    passwordRequirements: 'Passordkrav:',
    passwordStrong: 'Passordet oppfyller kravene',
    passwordMismatch: 'Passordene er ikke identiske',
    passwordMatch: 'Passordene er identiske',
    phoneRequired: 'Telefonnummer er påkrevd',
    phoneInvalid: 'Bruk format: +47 12345678',
    phoneValid: 'Gyldig telefonnummer',
    phoneFormat: 'Format: +47 12345678 (med landskode)',
    
    // Approval system errors
    accountPendingApproval: 'Kontoen venter på godkjenning fra administrator',
    accountRejected: 'Kontoen ble avvist av administrator',
    invalidLoginCredentials: 'Ugyldig påloggingsinformasjon',
    
    // Form validation
    fillAllFields: 'Vennligst fyll ut alle påkrevde felt korrekt',
    companyNameRequired: 'Firmanavn er påkrevd (minimum 2 tegn)',
    companyAddressRequired: 'Firmaadresse er påkrevd (minimum 5 tegn)',
    emailValid: 'Gyldig e-postadresse',
    companyNameValid: 'Gyldig firmanavn',
    companyAddressValid: 'Gyldig adresse',
    
    // Settings page
    manageCompanySettings: 'Administrer bedriftsinnstillinger',
    companyInformation: 'Bedriftsinformasjon',
    receptionPhone: 'Resepsjonstelefon',
    receptionPhoneDescription: 'Dette nummeret vises i appen for gjester som trenger hjelp',
    companyNamePlaceholder: 'Skriv inn firmanavn',
    settingsSaved: 'Innstillinger lagret!',
    settingsError: 'Feil ved lagring av innstillinger',
    logoTooLarge: 'Logo er for stort (maks 2MB)',
    logoInvalidType: 'Kun bildefiler er tillatt',
    logoUploaded: 'Logo lastet opp!',
    logoError: 'Feil ved opplasting av logo',
    confirmRemoveLogo: 'Er du sikker på at du vil fjerne logoen?',
    logoRemoved: 'Logo fjernet!',
    logoRemoveError: 'Feil ved fjerning av logo',
    logoRequirements: 'PNG, JPG eller SVG. Maks 2MB.',
    saveChanges: 'Lagre endringer',
    saving: 'Lagrer...'
  },
  
  en: {
    // Main
    appName: 'SafeVisit',
    appDescription: 'Visitor management that works',
    
    // Navigation
    dashboard: 'Dashboard',
    reception: 'Reception',
    logout: 'Logout',
    
    // Login
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    companyName: 'Company Name',
    companyAddress: 'Company Address',
    companyPhone: 'Company Phone',
    loginButton: 'Sign In',
    registerCompany: 'Register Company',
    
    // Dashboard
    currentGuests: 'Current Guests',
    fireAlarm: 'Fire Alarm',
    exportList: 'Export List',
    
    // Guest Form
    fullName: 'Full Name',
    company: 'Company',
    phone: 'Phone Number',
    hostName: 'Person Visiting',
    guestEmail: 'Email (optional)',
    emailDescription: 'ID card will be sent to this email',
    registerGuest: 'Register Guest',
    registering: 'Registering...',
    
    // Reception
    newGuest: 'New Guest',
    cancel: 'Cancel',
    newGuestRegistration: 'New Guest Registration',
    qrScanner: 'QR Scanner',
    scanDescription: 'Scan guest QR code to check them out',
    scannerNote: '(Scanner function requires camera and additional implementation)',
    
    // Guest Terminal
    welcomeTo: 'Welcome to',
    guestRegistration: 'Guest Registration',
    registrationComplete: 'Welcome!',
    registrationSuccess: 'You are now registered as a guest. Have a great day!',
    collectId: 'You can now visit the company',
    registerAnother: 'Register new guest',
    important: '',
    keepQr: 'Remember your phone number - it will be needed for checkout.',
    
    // Actions
    checkOut: 'Check Out',
    printBadge: 'Print',
    
    // Status
    noGuests: 'No guests on premises',
    present: 'Present',
    
    // Alarms
    confirmAlarm: 'Are you sure you want to trigger fire alarm?',
    alarmTriggered: 'Alarm triggered! Evacuation list generated.',
    
    // Errors
    registrationError: 'Registration Error',
    loadingError: 'Data Loading Error',
    
    // PDF
    guest: 'GUEST',
    guestId: 'GUEST ID',
    evacuationList: 'EVACUATION LIST',
    date: 'Date',
    numberOfPeople: 'Number of People',
    serialNumber: 'No.',
    nameHeader: 'Name',
    companyHeader: 'Company',
    phoneHeader: 'Phone',
    
    // Placeholders
    namePlaceholder: 'John Smith',
    companyPlaceholder: 'Company name',
    phonePlaceholder: '+44 123 456 789',
    hostPlaceholder: 'Jane Doe',
    emailPlaceholder: 'john@email.com',
    
    // Email messages
    emailWouldBeSent: 'ID card would be sent to',
    emailConfigRequired: 'Email function requires EmailJS or Supabase Functions configuration',
    collectIdMessage: 'Go to reception to collect your ID card',
    todayRegistered: 'Today Registered',
    quickRegistration: 'Quick Registration',
    receptionPanel: 'Reception Panel',
    panel: 'Panel',
    checkIn: 'Check In',
    guestTerminals: 'Guest Terminals',
    checkInRegistration: 'Check In (Registration)',
    checkOutDeparture: 'Check Out (Departure)',
    guestPanel: 'Guest Panel - Terminal Links',
    openRegistrationTerminal: 'Open registration terminal',
    openCheckoutTerminal: 'Open checkout terminal',
    copyLinkToEmail: 'Copy link to email',
    linkForSharing: 'Link for sharing',
    instructionsForUse: 'Instructions for use',
    forTabletKiosk: 'For tablet/kiosk:',
    forEmailInvitations: 'For email invitations:',
    clickOpenTerminal: 'Click "Open terminal" to open in fullscreen',
    placeTabletAtEntrance: 'Place tablet at entrance/exit',
    guestsCanSelfRegister: 'Guests can self-register',
    copyLinkAndSend: 'Copy link and send to guests',
    guestsCanPreRegister: 'Guests can pre-register',
    worksOnAllDevices: 'Works on all devices',
    terminalForNewGuests: 'Terminal for arriving guests',
    terminalForDepartingGuests: 'Terminal for departing guests',
    guestPanelDescription: 'Open panel with terminal links. You can send links by email or set up on tablet.',
    linkCopiedToClipboard: 'Link {type} copied to clipboard!',
    failedToCopyLink: 'Failed to copy link. Copy manually: {link}',
    copyManually: 'Failed to copy link. Copy manually:',
    triggeringAlarm: 'Triggering alarm...',
    checkingOut: 'Checking out...',
    checkoutComplete: 'Checkout Complete!',
    hasBeenCheckedOut: 'has been checked out',
    thanksForVisit: 'Thanks for your visit!',
    checkoutAnother: 'Check out another guest',
    noGuestsFound: 'No guests found with this number',
    scanQrDescription: 'Scan your QR code to check out',
    qrScannerNote: '(QR scanner requires camera and additional implementation)',
    guestsFound: 'Guests Found',
    clickToScan: 'Click to scan',
    holdQrToCamera: 'Hold QR code in front of camera',
    manualEntry: 'Manual entry',
    enterQrCode: 'Enter QR code:',
    qrNotFound: 'No guest found with this QR code',
    qrScanError: 'QR code scanning error',
    cameraError: 'Camera access error',
    cameraNotSupported: 'Camera not supported in this browser',
    frontCamera: 'Front Camera',
    backCamera: 'Back Camera',
    invalidPhone: 'Invalid phone number. Use format: 12345678 or +47 12345678',
    invalidEmail: 'Invalid email address',
    recentCheckouts: 'Recent Checkouts',
    noRecentCheckouts: 'No recent checkouts',
    duration: 'Duration',

    privacyPolicy: 'Privacy Policy',
    lastUpdated: 'Last updated',
    privacyNotice: 'By registering you accept our',
    privacyConsent: 'I accept the',
    privacyRequired: 'You must accept the privacy policy to continue',
    dataDeletedOnCheckout: 'Your data will be automatically deleted when you check out',
    phoneRequired: 'Phone number is required',
    needHelp: 'Need help? Contact reception',
    thankYou: 'Thank you!',
    noInternet: 'No internet connection',
    tapToRegister: 'Tap here to register',
    tapToCheckout: 'Tap here to check out',
    hostPhone: 'Host phone number',
    hostPhonePlaceholder: '+44 987 654 321',
    hostPhoneDescription: 'To notify about arrival',
    hostPhoneRequired: 'Host phone number is required',
    smsNotification: 'Guest arrived',
    emergencySMS: 'Emergency SMS sent',
    smsResults: 'SMS results',
    smsSent: 'SMS sent',
    smsSimulation: 'SMS simulation - check console',
    
    // Terminal translations
    systemActive: 'System active',
    connected: 'Connected',
    disconnected: 'Disconnected',
    lastUpdated: 'Last updated',
    newGuest: 'New guest',
    register: 'Register',
    fillInformation: 'Fill in your information',
    getAccess: 'Get access to building',
    notifyContact: 'Notify your contact person',
    clickToStart: 'Click to start',
    leaving: 'Leaving',
    enterPhone: 'Enter your phone number',
    confirmCheckout: 'Confirm checkout',
    clickToCheckout: 'Click to check out',
    howToUse: 'How to use the terminal',
    step1: 'Select "Register" when you arrive',
    step2: 'Fill out the form with your information',
    step3: 'Check out when you leave the building',
    needHelp: 'Need help?',
    contactReception: 'Contact reception if you have problems',
    callReception: 'Call reception',
    orGoToReception: 'Or go to reception for personal help',
    
    // Registration and checkout specific
    pleaseFillinformation: 'Please fill in the information below',
    nowRegistered: 'You are now registered as a guest',
    goToReceptionOrHost: 'Go to reception or to the person you are visiting',
    rememberPhone: 'Remember your phone number',
    neededForCheckout: 'You will need this for checkout when leaving the building',
    informReception: 'Inform reception when you leave the building',
    orUseCheckoutTerminal: 'Or use the checkout terminal at the exit',
    autoReturn: 'Automatic return to terminal in',
    seconds: 'seconds',
    backToTerminalNow: 'Back to terminal now',
    enterPhoneToCheckout: 'Enter your phone number to check out',
    searching: 'Searching...',
    nowCheckedOut: 'You are now checked out of the building',
    haveNiceDay: 'Have a nice day!',
    
    // Form validation
    companyRequired: 'Company is required',
    emailRequired: 'Email is required',
    
    // Welcome messages
    welcomeMessage: 'Welcome!',
    
    // Registration approval system
    registrationPending: 'Registration sent! Wait for administrator approval.',
    guestManagementSystem: 'Visitor management that works',
    signIn: 'Sign In',
    loading: 'Loading...',
    settings: 'Settings',
    companyLogo: 'Company Logo',
    removeLogo: 'Remove logo',
    uploading: 'Uploading...',
    uploadLogo: 'Upload logo',
    chooseFile: 'Choose file',
    back: 'Back',
    forgotPassword: 'Forgot password?',
    resetEmailSent: 'Password reset email sent!',
    resetError: 'Error sending password reset email',
    confirmPassword: 'Confirm password',
    passwordMinLength: 'Minimum 8 characters',
    passwordUppercase: 'One uppercase letter',
    passwordLowercase: 'One lowercase letter',
    passwordNumber: 'One number',
    passwordSpecial: 'One special character (!@#$%^&*)',
    passwordRequirements: 'Password requirements:',
    passwordStrong: 'Password meets requirements',
    passwordMismatch: 'Passwords do not match',
    passwordMatch: 'Passwords match',
    phoneRequired: 'Phone number is required',
    phoneInvalid: 'Use format: +44 1234567890',
    phoneValid: 'Valid phone number',
    phoneFormat: 'Format: +44 1234567890 (with country code)',
    
    // Approval system errors
    accountPendingApproval: 'Account pending administrator approval',
    accountRejected: 'Account rejected by administrator',
    invalidLoginCredentials: 'Invalid login credentials',
    
    // Form validation
    fillAllFields: 'Please fill out all required fields correctly',
    companyNameRequired: 'Company name is required (minimum 2 characters)',
    companyAddressRequired: 'Company address is required (minimum 5 characters)',
    emailValid: 'Valid email address',
    companyNameValid: 'Valid company name',
    companyAddressValid: 'Valid address',
    
    // Settings page
    manageCompanySettings: 'Manage company settings',
    companyInformation: 'Company Information',
    receptionPhone: 'Reception Phone',
    receptionPhoneDescription: 'This number is displayed in the app for guests who need help',
    companyNamePlaceholder: 'Enter company name',
    settingsSaved: 'Settings saved!',
    settingsError: 'Error saving settings',
    logoTooLarge: 'Logo is too large (max 2MB)',
    logoInvalidType: 'Only image files are allowed',
    logoUploaded: 'Logo uploaded!',
    logoError: 'Error uploading logo',
    confirmRemoveLogo: 'Are you sure you want to remove the logo?',
    logoRemoved: 'Logo removed!',
    logoRemoveError: 'Error removing logo',
    logoRequirements: 'PNG, JPG or SVG. Max 2MB.',
    saveChanges: 'Save Changes',
    saving: 'Saving...'
  },
  
  pl: {
    // Główne
    appName: 'SafeVisit',
    appDescription: 'Visitor management that works',
    
    // Nawigacja
    dashboard: 'Panel główny',
    reception: 'Recepcja',
    logout: 'Wyloguj',
    
    // Logowanie
    login: 'Logowanie',
    register: 'Rejestracja',
    email: 'Email',
    password: 'Hasło',
    companyName: 'Nazwa firmy',
    companyAddress: 'Adres firmy',
    companyPhone: 'Telefon firmy',
    loginButton: 'Zaloguj się',
    registerCompany: 'Zarejestruj firmę',
    
    // Dashboard
    currentGuests: 'Obecni goście',
    fireAlarm: 'Alarm pożarowy',
    exportList: 'Eksportuj listę',
    
    // Formularz gościa
    fullName: 'Imię i nazwisko',
    company: 'Firma',
    phone: 'Numer telefonu',
    hostName: 'Osoba odwiedzana',
    guestEmail: 'Email (opcjonalnie)',
    emailDescription: 'Identyfikator zostanie wysłany na ten email',
    registerGuest: 'Zarejestruj gościa',
    registering: 'Rejestrowanie...',
    
    // Recepcja
    newGuest: 'Nowy gość',
    cancel: 'Anuluj',
    newGuestRegistration: 'Rejestracja nowego gościa',
    qrScanner: 'Skaner QR',
    scanDescription: 'Zeskanuj kod QR gościa, aby go wymeldować',
    scannerNote: '(Funkcja skanera wymaga kamery i dodatkowej implementacji)',
    
    // Terminal gości
    welcomeTo: 'Witamy w',
    guestRegistration: 'Rejestracja gościa',
    registrationComplete: 'Witamy!',
    registrationSuccess: 'Jesteś teraz zarejestrowany jako gość. Miłego dnia!',
    collectId: 'Możesz teraz odwiedzić firmę',
    registerAnother: 'Zarejestruj nowego gościa',
    important: '',
    keepQr: 'Zapamiętaj swój numer telefonu - będzie potrzebny przy wymeldowaniu.',
    
    // Akcje
    checkOut: 'Wymelduj',
    printBadge: 'QR',
    
    // Statusy
    noGuests: 'Brak gości na terenie',
    present: 'Obecny',
    
    // Alarmy
    confirmAlarm: 'Czy na pewno chcesz wywołać alarm pożarowy?',
    alarmTriggered: 'Alarm wywołany! Lista ewakuacyjna została wygenerowana.',
    
    // Błędy
    registrationError: 'Błąd rejestracji gościa',
    loadingError: 'Błąd ładowania danych',
    
    // PDF
    guest: 'GOSC',
    guestId: 'IDENTYFIKATOR GOSCIA',
    evacuationList: 'LISTA EWAKUACYJNA',
    date: 'Data',
    numberOfPeople: 'Liczba osób',
    serialNumber: 'Lp.',
    nameHeader: 'Imie i nazwisko',
    companyHeader: 'Firma',
    phoneHeader: 'Telefon',
    
    // Placeholders
    namePlaceholder: 'Jan Kowalski',
    companyPlaceholder: 'Nazwa firmy',
    phonePlaceholder: '+48 123 456 789',
    hostPlaceholder: 'Anna Nowak',
    emailPlaceholder: 'jan@email.pl',
    
    // Email messages
    emailWouldBeSent: 'Identyfikator zostałby wysłany na',
    emailConfigRequired: 'Funkcja emaila wymaga konfiguracji EmailJS lub Supabase Functions',
    collectIdMessage: 'Zgłoś się do recepcji po odbiór identyfikatora',
    todayRegistered: 'Dzisiaj zarejestrowano',
    quickRegistration: 'Szybka rejestracja',
    receptionPanel: 'Panel Recepcji',
    panel: 'Panel',
    checkIn: 'Wejście',
    guestTerminals: 'Terminale Gości',
    checkInRegistration: 'Zameldowanie (Rejestracja)',
    checkOutDeparture: 'Wymeldowanie (Wyjście)',
    guestPanel: 'Panel Gości - Linki do Terminali',
    openRegistrationTerminal: 'Otwórz terminal rejestracji',
    openCheckoutTerminal: 'Otwórz terminal wyrejestrowania',
    copyLinkToEmail: 'Kopiuj link do emaila',
    linkForSharing: 'Link do udostępnienia',
    instructionsForUse: 'Instrukcje użytkowania',
    forTabletKiosk: 'Dla tabletu/kiosku:',
    forEmailInvitations: 'Dla zaproszeń email:',
    clickOpenTerminal: 'Kliknij "Otwórz terminal" aby otworzyć na pełnym ekranie',
    placeTabletAtEntrance: 'Umieść tablet przy wejściu/wyjściu',
    guestsCanSelfRegister: 'Goście mogą się sami rejestrować',
    copyLinkAndSend: 'Skopiuj link i wyślij gościom',
    guestsCanPreRegister: 'Goście mogą się zarejestrować wcześniej',
    worksOnAllDevices: 'Działa na wszystkich urządzeniach',
    terminalForNewGuests: 'Terminal dla przybywających gości',
    terminalForDepartingGuests: 'Terminal dla wyjeżdżających gości',
    guestPanelDescription: 'Otwórz panel z linkami do terminali. Możesz wysłać linki mailem lub ustawić na tablecie.',
    linkCopiedToClipboard: 'Link {type} został skopiowany do schowka!',
    failedToCopyLink: 'Nie udało się skopiować linku. Skopiuj ręcznie: {link}',
    copyManually: 'Nie udało się skopiować linku. Skopiuj ręcznie:',
    triggeringAlarm: 'Wywoływanie alarmu...',
    checkingOut: 'Wymeldowywanie...',
    checkoutComplete: 'Wymeldowanie zakończone!',
    hasBeenCheckedOut: 'został wymeldowany',
    thanksForVisit: 'Dziękujemy za wizytę!',
    checkoutAnother: 'Wymelduj kolejnego gościa',
    noGuestsFound: 'Nie znaleziono gości o tym numerze',
    scanQrDescription: 'Zeskanuj swój kod QR aby się wymeldować',
    qrScannerNote: '(Skaner QR wymaga kamery i dodatkowej implementacji)',
    guestsFound: 'Znalezieni goście',
    clickToScan: 'Kliknij aby zeskanować',
    holdQrToCamera: 'Trzymaj kod QR przed kamerą',
    manualEntry: 'Wprowadź ręcznie',
    enterQrCode: 'Wprowadź kod QR:',
    qrNotFound: 'Nie znaleziono gościa z tym kodem QR',
    qrScanError: 'Błąd skanowania kodu QR',
    cameraError: 'Błąd dostępu do kamery',
    cameraNotSupported: 'Kamera nie jest obsługiwana w tej przeglądarce',
    frontCamera: 'Przednia kamera',
    backCamera: 'Tylna kamera',
    invalidPhone: 'Nieprawidłowy numer telefonu. Użyj formatu: 12345678 lub +47 12345678',
    invalidEmail: 'Nieprawidłowy adres email',
    recentCheckouts: 'Ostatnio wymeldowani',
    noRecentCheckouts: 'Brak ostatnich wymeldowań',
    duration: 'Czas trwania',

    privacyPolicy: 'Polityka Prywatności',
    lastUpdated: 'Ostatnia aktualizacja',
    privacyNotice: 'Rejestrując się akceptujesz naszą',
    privacyConsent: 'Akceptuję',
    privacyRequired: 'Musisz zaakceptować politykę prywatności aby kontynuować',
    dataDeletedOnCheckout: 'Twoje dane zostaną automatycznie usunięte przy wymeldowaniu',
    phoneRequired: 'Numer telefonu jest wymagany',
    needHelp: 'Potrzebujesz pomocy? Skontaktuj się z recepcją',
    thankYou: 'Dziękuję!',
    noInternet: 'Brak połączenia internetowego',
    tapToRegister: 'Kliknij aby się zarejestrować',
    tapToCheckout: 'Kliknij aby się wymeldować',
    hostPhone: 'Telefon gospodarza',
    hostPhonePlaceholder: '+48 987 654 321',
    hostPhoneDescription: 'Do powiadomienia o przybyciu',
    hostPhoneRequired: 'Telefon gospodarza jest wymagany',
    smsNotification: 'Gość przybył',
    emergencySMS: 'SMS alarmowy wysłany',
    smsResults: 'Wyniki SMS',
    smsSent: 'SMS wysłane',
    smsSimulation: 'Symulacja SMS - sprawdź konsolę',
    
    // Terminal translations
    systemActive: 'System aktywny',
    connected: 'Połączony',
    disconnected: 'Rozłączony',
    lastUpdated: 'Ostatnia aktualizacja',
    newGuest: 'Nowy gość',
    register: 'Zarejestruj się',
    fillInformation: 'Wypełnij swoje dane',
    getAccess: 'Uzyskaj dostęp do budynku',
    notifyContact: 'Powiadom swoją osobę kontaktową',
    clickToStart: 'Kliknij aby rozpocząć',
    leaving: 'Wychodzi',
    enterPhone: 'Wprowadź swój numer telefonu',
    confirmCheckout: 'Potwierdź wymeldowanie',
    clickToCheckout: 'Kliknij aby się wymeldować',
    howToUse: 'Jak korzystać z terminala',
    step1: 'Wybierz "Zarejestruj się" gdy przybędziesz',
    step2: 'Wypełnij formularz swoimi danymi',
    step3: 'Wymelduj się gdy opuszczasz budynek',
    needHelp: 'Potrzebujesz pomocy?',
    contactReception: 'Skontaktuj się z recepcją jeśli masz problemy',
    callReception: 'Zadzwoń do recepcji',
    orGoToReception: 'Lub idź do recepcji po osobistą pomoc',
    
    // Registration and checkout specific
    pleaseFillinformation: 'Proszę wypełnić informacje poniżej',
    nowRegistered: 'Jesteś teraz zarejestrowany jako gość',
    goToReceptionOrHost: 'Idź do recepcji lub do osoby, którą odwiedzasz',
    rememberPhone: 'Zapamiętaj swój numer telefonu',
    neededForCheckout: 'Będziesz tego potrzebować przy wymeldowaniu',
    informReception: 'Poinformuj recepcję gdy opuszczasz budynek',
    orUseCheckoutTerminal: 'Lub użyj terminala wymeldowania przy wyjściu',
    autoReturn: 'Automatyczny powrót do terminala za',
    seconds: 'sekund',
    backToTerminalNow: 'Powróć do terminala teraz',
    enterPhoneToCheckout: 'Wprowadź swój numer telefonu aby się wymeldować',
    searching: 'Szukam...',
    nowCheckedOut: 'Jesteś teraz wymeldowany z budynku',
    haveNiceDay: 'Miłego dnia!',
    
    // Form validation
    companyRequired: 'Firma jest wymagana',
    emailRequired: 'Email jest wymagany',
    
    // Welcome messages
    welcomeMessage: 'Witamy!',
    
    // Registration approval system
    registrationPending: 'Rejestracja wysłana! Oczekuj na zatwierdzenie przez administratora.',
    guestManagementSystem: 'Visitor management that works',
    signIn: 'Zaloguj się',
    loading: 'Ładowanie...',
    settings: 'Ustawienia',
    companyLogo: 'Logo firmy',
    removeLogo: 'Usuń logo',
    uploading: 'Przesyłanie...',
    uploadLogo: 'Prześlij logo',
    chooseFile: 'Wybierz plik',
    back: 'Powrót',
    forgotPassword: 'Zapomniałeś hasła?',
    resetEmailSent: 'Email z resetem hasła został wysłany!',
    resetError: 'Błąd podczas wysyłania emaila z resetem hasła',
    confirmPassword: 'Potwierdź hasło',
    passwordMinLength: 'Minimum 8 znaków',
    passwordUppercase: 'Jedna wielka litera',
    passwordLowercase: 'Jedna mała litera',
    passwordNumber: 'Jedna cyfra',
    passwordSpecial: 'Jeden znak specjalny (!@#$%^&*)',
    passwordRequirements: 'Wymagania dotyczące hasła:',
    passwordStrong: 'Hasło spełnia wymagania',
    passwordMismatch: 'Hasła nie są identyczne',
    passwordMatch: 'Hasła są identyczne',
    phoneRequired: 'Numer telefonu jest wymagany',
    phoneInvalid: 'Użyj formatu: +48 123456789',
    phoneValid: 'Prawidłowy numer telefonu',
    phoneFormat: 'Format: +48 123456789 (z kodem kraju)',
    
    // Approval system errors
    accountPendingApproval: 'Konto oczekuje na zatwierdzenie przez administratora',
    accountRejected: 'Konto zostało odrzucone przez administratora',
    invalidLoginCredentials: 'Nieprawidłowe dane logowania',
    
    // Form validation
    fillAllFields: 'Proszę wypełnić wszystkie wymagane pola poprawnie',
    companyNameRequired: 'Nazwa firmy jest wymagana (minimum 2 znaki)',
    companyAddressRequired: 'Adres firmy jest wymagany (minimum 5 znaków)',
    emailValid: 'Prawidłowy adres email',
    companyNameValid: 'Prawidłowa nazwa firmy',
    companyAddressValid: 'Prawidłowy adres',
    
    // Settings page
    manageCompanySettings: 'Zarządzaj ustawieniami firmy',
    companyInformation: 'Informacje o firmie',
    receptionPhone: 'Telefon recepcji',
    receptionPhoneDescription: 'Ten numer jest wyświetlany w aplikacji dla gości potrzebujących pomocy',
    companyNamePlaceholder: 'Wprowadź nazwę firmy',
    settingsSaved: 'Ustawienia zapisane!',
    settingsError: 'Błąd zapisu ustawień',
    logoTooLarge: 'Logo jest za duże (maks 2MB)',
    logoInvalidType: 'Dozwolone są tylko pliki graficzne',
    logoUploaded: 'Logo przesłane!',
    logoError: 'Błąd przesyłania logo',
    confirmRemoveLogo: 'Czy na pewno chcesz usunąć logo?',
    logoRemoved: 'Logo usunięte!',
    logoRemoveError: 'Błąd usuwania logo',
    logoRequirements: 'PNG, JPG lub SVG. Maks 2MB.',
    saveChanges: 'Zapisz zmiany',
    saving: 'Zapisywanie...'
  }
}

export const useTranslation = (language = 'no') => {
  const t = (key) => {
    return translations[language]?.[key] || translations['no'][key] || key
  }
  
  return { t }
}